import { render, staticRenderFns } from "./inquiryList.vue?vue&type=template&id=3b77e6d0&scoped=true"
import script from "./inquiryList.vue?vue&type=script&lang=js"
export * from "./inquiryList.vue?vue&type=script&lang=js"
import style0 from "./inquiryList.vue?vue&type=style&index=0&id=3b77e6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b77e6d0",
  null
  
)

export default component.exports